import axios from 'axios'
import ActionsLogin from './LoginActions'

const config = {
  headers: {
    Authorization: 'Bearer ' + ActionsLogin.getToken()
  }
}

const cadastrarTipoServico = ({
  descricao,
  observacao,
  idc_status,
  idc_instalacao
}) => {
  return axios.post(
    process.env.URL_API_BASE + '/servico-tipo',
    {
      descricao: descricao,
      observacao: observacao,
      idc_status: idc_status,
      idc_instalacao: idc_instalacao,
      created_by: ActionsLogin.getUsuario().cd_usuario
    },
    config
  )
}

const alterarTipoServico = ({
  id,
  descricao,
  observacao,
  idc_status,
  idc_instalacao
}) => {
  return axios.patch(
    process.env.URL_API_BASE + '/servico-tipo/' + id,
    {
      descricao: descricao,
      observacao: observacao,
      idc_status: idc_status,
      idc_instalacao: idc_instalacao,
      updated_by: ActionsLogin.getUsuario().cd_usuario
    },
    config
  )
}

const listarTipoServico = async () => {
  let response = await axios.get(
    process.env.URL_API_BASE + '/servico-tipo',
    config
  )
  return response.data
}

export const obterTipoServico = async id => {
  let response = await axios.get(
    process.env.URL_API_BASE + '/servico-tipo/' + id,
    config
  )
  return response.data
}

const listarTipoServicosAtivos = async () => {
  let response = await axios.get(
    process.env.URL_API_BASE + '/servico-tipo/listar-ativos/1',
    config
  )
  return response.data
}

export default {
  cadastrarTipoServico,
  alterarTipoServico,
  listarTipoServico,
  obterTipoServico,
  listarTipoServicosAtivos
}



// WEBPACK FOOTER //
// ./src/actions/ServicoTipoActions.js